export default __webpack_public_path__ + "static/media/battery.24d594b2.svg";